import { Upload, Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { SLOTS } from "./shared";

export function PortalPhotos({ uploads, onUpload, onDelete }) {
  return (
    <div className="de-card p-6">
      <div className="label-eyebrow mb-4">Photos by location</div>
      {SLOTS.map(([key, label]) => {
        const items = uploads.filter(u => u.slot === key);
        return (
          <div key={key} className="border-t border-[#E5E7EB] py-4">
            <div className="flex items-center justify-between mb-2">
              <div className="font-bold">{label}</div>
              <label data-testid={`upload-${key}`} className="text-xs uppercase tracking-widest text-[#C79A3B] cursor-pointer inline-flex items-center gap-1">
                <Upload size={14}/> Upload
                <input type="file" accept="image/*" multiple className="hidden" onChange={(e)=>Array.from(e.target.files).forEach(f=>onUpload(key,f))}/>
              </label>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-5 gap-2">
              {items.map(it => (
                <div key={it.id} className="relative">
                  <img src={`${api.defaults.baseURL}/portal/file/${it.id}`} className="w-full h-24 object-cover" alt=""/>
                  <button data-testid={`delete-${it.id}`} onClick={()=>onDelete(it.id)} className="absolute top-1 right-1 bg-[#12263A] text-white p-1"><Trash2 size={12}/></button>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
